import React from 'react';

const Sourcing = (props) => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/P&amp;S b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-386.000000, -289.000000)" fill="#000000">
                <g id="Icon/Navigation/Category/24-Copy" transform="translate(386.000000, 289.000000)">
                    <path
                        d="M14.25,21 C14.6642136,21 15,21.3357864 15,21.75 C15,22.1181898 14.7346873,22.4244126 14.3848134,22.4879165 L14.25,22.5 L9.75,22.5 C9.33578644,22.5 9,22.1642136 9,21.75 C9,21.3818102 9.26531274,21.0755874 9.61518655,21.0120835 L9.75,21 L14.25,21 Z M12,1.5 C16.1421356,1.5 19.5,5.0257576 19.5,9.375 C19.5,12.3666754 17.911216,14.9687164 15.5712591,16.3016313 L15.5714286,18.375 C15.5714286,18.9963203 15.0677489,19.5 14.4464286,19.5 L9.55357143,19.5 C8.93225109,19.5 8.42857143,18.9963203 8.42857143,18.375 L8.42874093,16.3016313 C6.08878404,14.9687164 4.5,12.3666754 4.5,9.375 C4.5,5.0257576 7.85786438,1.5 12,1.5 Z M12,3 C8.70310247,3 6,5.8382576 6,9.375 C6,11.6442528 7.12394874,13.6933529 8.89995179,14.8340532 L9.17118367,14.9982592 L9.92881221,15.4298288 L9.9285,18 L11.2524851,18 L11.2518673,13.4320464 C10.162594,13.2320264 9.19913803,12.6008728 8.57704838,11.6775792 C8.34559695,11.3340634 8.43644309,10.8679603 8.7799589,10.6365089 C9.12347471,10.4050575 9.58957775,10.4959036 9.82102917,10.8394194 C10.3064865,11.5599259 11.1153758,12 12,12 C12.8870762,12 13.6979351,11.5574565 14.1828386,10.8336626 C14.4133838,10.4895379 14.8792458,10.3974636 15.2233704,10.6280088 C15.5674951,10.858554 15.6595694,11.324416 15.4290242,11.6685406 C14.8082084,12.595205 13.8440335,13.2294007 12.7531634,13.4311182 L12.7524851,18 L14.07,18 L14.0711878,15.4298288 L14.8288163,14.9982592 C16.7608465,13.8977125 18,11.7577154 18,9.375 C18,5.8382576 15.2968975,3 12,3 Z"
                        id="🎨-Color"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default Sourcing;
